
<template>
    <vs-dialog v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
            HISTORIAL
          </h4>
        </template>


        <div class="con-form">
            <div v-if="users.length" class="center examplex">
                <vs-row class="cabeceras">
                    <vs-col class="text-uppercase" w="4"><strong>Usuario</strong></vs-col>
                    <vs-col class="text-uppercase" w="4"><strong>Materia</strong></vs-col>
                    <vs-col class="text-uppercase" w="4"><strong>Calificación anterior</strong></vs-col>
                </vs-row>
                <vs-row class="historial" v-for="(log, i) in users" :key="i">
                    <vs-col w="4">
                        <p class="mb-0"><strong>{{log.usuario}}</strong></p>
                        <p class="mb-0"><small>FECHA MODIFICACIÓN</small></p>
                        <p class="mb-0"><strong><i class="far fa-calendar mr-2"></i>{{log.fecha}}</strong></p>
                    </vs-col>
                    <vs-col w="4">
                        <p class="mb-0"><strong>{{log.materia}}</strong></p>
                        <p class="mb-0"><small>PERIODO</small></p>
                        <p class="mb-0"><strong>{{log.periodo}}</strong></p>
                    </vs-col>
                    <vs-col w="4">
                        <p class="mb-0"><strong>{{log.calificacion_anterior}}</strong></p>
                    </vs-col>
                </vs-row>
            </div>
            <h5 class="text-center" v-else>No hay historial de movimientos</h5>
        </div>
    </vs-dialog>
</template>
<script>
export default {
    props:[
        'value',
        'users'
    ],
    data:() => ({
        active: false
    }),
    watch:{
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cabeceras{
    padding: 5px;
}
.historial{
    padding: 2%;
    background: #FAFAFA;
    margin: 1% 0;
    border-radius: 5px;
}
</style>

        